import { useEffect } from "react"
import { HashRouter as Router, Route, Routes } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { Box, CssBaseline } from "@mui/material"
import { createTheme, responsiveFontSizes } from "@mui/material/styles"
import { ThemeProvider } from "@mui/material/styles"
import Navigation from "./Navigation"
import LoginPage from "../login/LoginPage"
import UserNotFound from "../login/UserNotFound"
import HomePage from "../home/HomePage"
import Footer from "./Footer"
import RolesPage from "../accessManagement/roles/RolesPage"
import PermissionsPage from "../accessManagement/permissions/PermissionsPage"
import "../../fonts/fonts.css"
import { useAuth } from "../../functions/useAuth"
import resetHeaders from "../../functions/resetHeaders"

function App() {
    const dispatch = useDispatch()
    useAuth(dispatch)

    const loggedIn = useSelector(
        (state) => state.auth.user && state.auth.user.auth
    )
    const userData = useSelector((state) => state.auth.userData)

    useEffect(() => {
        if (loggedIn) {
            resetHeaders()
        }
        return () => {}
    }, [loggedIn])

    let palette = {
        primary: { main: "#717073" },
        secondary: { main: "#DF7A00" }
    }

    if (userData) {
        palette = { ...palette, mode: userData.DarkMode }
    }

    const background = palette.mode === "dark"
    ? { default: "#303030", paper: "#424242", appBar: "#717073" }
    : { default: "#fafafa", paper: "#ffffff", appBar: "#ffffff" }

    let theme = createTheme({
        palette: {
            ...palette,
            background, 
        },
        typography: {
            fontFamily: "Century",
        },
        components: {
            MuiCssBaseline: {
                styleOverrides: {
                    body: {
                        backgroundColor: background.default, 
                        overflowX: 'hidden',
                        margin: 0,
                        padding: 0,
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        backgroundColor: background.paper,
                        backgroundImage: "none",
                    },
                },
            },
            MuiAppBar: {
                styleOverrides: {
                    root: {
                        backgroundColor: background.appBar,
                    },
                },
            },
            MuiInputBase: {
                styleOverrides: {
                    input: {
                        fontSize: '14px', 
                    },
                    textarea: {
                        fontSize: '14px', 
                    },
                },
            },
            MuiSwitch: {
                styleOverrides: {
                    switchBase: {
                        '&.Mui-checked': {
                            color: '#DF7A00', 
                            '& + .MuiSwitch-track': {
                                backgroundColor: '#DF7A00', 
                            },
                        },
                    },
                },
            },
        },
    });

    theme = responsiveFontSizes(theme)
    const ComponentPage = (page) => {
        return (
            <>
                <Navigation />
                <main style={{ flex: 1 }}>{page}</main>
                <Footer />
            </>
        )
    }

    return (
        <ThemeProvider theme={responsiveFontSizes(theme)}>
            <Router>
                <CssBaseline />
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100vh",
                        bgcolor: background.default,
                    }}
                >
                    <Routes>
                    <Route path="/" exact element={<LoginPage />} />
                    <Route
                        path="/user-not-found"
                        exact
                        element={ComponentPage(<UserNotFound />)}
                    />
                    <Route
                        path="/home"
                        exact
                        element={ComponentPage(<HomePage />)}
                    />
                    <Route
                        path="/roles"
                        exact
                        element={ComponentPage(<RolesPage />)}
                    />
                    <Route
                        path="/permissions"
                        exact
                        element={ComponentPage(<PermissionsPage />)}
                    />
                </Routes>
                </Box>
                
            </Router>
        </ThemeProvider>
    )
}

export default App
